// Jump the window to the top without the smooth animation that `html { scroll-behavior: smooth }`
// would otherwise apply. The repeat on the next frames covers Safari clamping the position while
// the new route's document height is still settling.
export function scrollWindowToTop() {
  const jump = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
    const el = document.scrollingElement;
    if (el && el.scrollTop !== 0) el.scrollTop = 0;
    if (document.body && document.body.scrollTop !== 0) document.body.scrollTop = 0;
  };
  jump();
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(() => {
      jump();
      requestAnimationFrame(jump);
    });
  }
}
